import React from "react";
import PropTypes from "prop-types";
import clsx from "classnames";
import { enums } from "../../enums";

import "./style.scss";

const Select = ({
  label,
  size,
  onChange,
  options,
  name,
  required,
  placeholder,
  className,
  labelClassName,
  disabled,
  hasError,
  state,
  style,
  loading,
  ...rest
}) => {
  const selectBaseClass = "pm-select";

  const selectFieldClasses = clsx(
    selectBaseClass,
    className,
    `${selectBaseClass}--${state}`,
    `${selectBaseClass}--${size}`,
    `${hasError ? `${selectBaseClass}--error` : ""}`
  );

  const labelBaseClass = "pm-label";
  const labelClasses = clsx(labelBaseClass, labelClassName);

  return (
    <>
      <label htmlFor={name} className={labelClasses}>
        {label}
        {required && (
          <span style={{ marginLeft: ".2rem" }} className="font-danger">
            *
          </span>
        )}
      </label>
      <select
        required
        name={name}
        onChange={onChange}
        className={selectFieldClasses}
        // defaultValue=""
        disabled={disabled}
        style={style}
        {...rest}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {loading ? (
          <option value="">Loading...</option>
        ) : (
          options?.map(({ value, label }, key) => (
            <option value={value} key={key}>
              {label}
            </option>
          ))
        )}
      </select>
    </>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  // onChange: PropTypes.func.isRequired,
  // options: PropTypes.array.isRequired,
  // name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  state: PropTypes.oneOf(enums.inputFieldStates),
  required: PropTypes.bool,
  size: PropTypes.oneOf(enums.componentSizes),
  loading: PropTypes.bool,
};

Select.defaultProps = {
  state: "default",
  placeholder: "",
  required: true,
  size: "md",
};

export default Select;
